import { Text, Topic } from '../types';

export function getDescription(topic: Topic) {
    const shortDescNode = topic?.children?.find((el) => el.name === 'shortdesc');
    return (shortDescNode?.children?.[0] as Text)?.value;
}
